var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultCover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 353,
    height: 198,
    viewBox: "0 0 353 198",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Frame",
    d: "M6,0H347a6,6,0,0,1,6,6V198a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V6A6,6,0,0,1,6,0Z",
    transform: "translate(20 109)",
    fill: "#08bf5b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "default-cover",
    transform: "translate(-20 -109)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Frame-2",
    "data-name": "Frame",
    d: "M6,0H347a6,6,0,0,1,6,6V198a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V6A6,6,0,0,1,6,0Z",
    transform: "translate(20 109)",
    fill: "#eff5f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_22",
    "data-name": "Exclusion 22",
    d: "M17.853,100h-.1a18.182,18.182,0,0,1-11.6-4.772A18.068,18.068,0,0,1,.233,84.19,23.214,23.214,0,0,1,.05,81.217c0-3.174-.012-6.4-.025-9.523C0,64.706-.034,57.482.1,50.38A38.754,38.754,0,0,1,1.943,39.122a33.933,33.933,0,0,1,12.55-17.187,39.588,39.588,0,0,1,10.163-5.242,40.373,40.373,0,0,1,13.3-2.36,36.429,36.429,0,0,1,10.067,1.43c.387.111.775.245,1.15.374.183.063.361.124.54.184-.372.056-.748.11-1.113.163l-.039.006c-1.533.221-2.981.43-4.437.784A30.8,30.8,0,0,0,31.975,23.15a33.744,33.744,0,0,0-8.492,10.48,43.623,43.623,0,0,0-4.765,16.14A81.482,81.482,0,0,0,18.447,59.8c.02,1.4.041,2.854.029,4.282-.029,3.507-.006,7.07.016,10.516v.031c.011,1.74.023,3.539.027,5.308q.007,3.057.011,6.114c.007,4.316.013,8.774.038,13.16a.869.869,0,0,1-.157.636A.75.75,0,0,1,17.853,100ZM37.379,89.367a45.044,45.044,0,0,1-13.327-2.1.717.717,0,0,1-.62-.8c.017-6.805.021-13.974.014-21.308,0-.1.01-.207.023-.336.007-.073.015-.153.022-.246l.389.312.009.007c.235.189.458.367.678.541a22.589,22.589,0,0,0,10.368,5,21.255,21.255,0,0,0,3.51.3c5.743,0,10.524-2.6,14.209-7.724a19.194,19.194,0,0,0,3.118-6.7,17.682,17.682,0,0,0,.28-6.981,18.41,18.41,0,0,0-2.45-6.638,21.087,21.087,0,0,0-5.072-5.674A16.412,16.412,0,0,0,38.2,33.352a21.659,21.659,0,0,0-6.927,1.236A27.375,27.375,0,0,0,27.246,36.4c-.01-.027-.022-.051-.032-.072-.019-.038-.032-.065-.024-.08,4-6.871,8.985-11.371,15.232-13.759a24.422,24.422,0,0,1,8.7-1.718,20.9,20.9,0,0,1,12.87,4.578,29.242,29.242,0,0,1,5.936,6.5,30.492,30.492,0,0,1,4.22,10.1,45.526,45.526,0,0,1,.984,11.375,36.421,36.421,0,0,1-2.5,12.344A37.411,37.411,0,0,1,56.871,84.182a36.554,36.554,0,0,1-11.785,4.455A41.264,41.264,0,0,1,37.379,89.367ZM9.471,18.948a9.359,9.359,0,0,1-6.658-2.755,9.511,9.511,0,1,1,6.723,2.755Z",
    transform: "translate(158.923 162)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultCover);
export default __webpack_public_path__ + "static/media/default-cover.c0c1634e6928fc9ba17e595c423a702e.svg";
export { ForwardRef as ReactComponent };